module.exports = __webpack_public_path__ + "static/media/Developmenticon01@2x.e1cb3f24.png";